//#region src/utils.ts
const isDisposable = (value) => {
	return typeof value === "object" && value !== null && "dispose" in value && typeof value.dispose === "function";
};
//#endregion
//#region src/composite_disposable.ts
/**
* Represents a group of Disposables that are disposed together
*/
var CompositeDisposable = class {
	#disposables = /* @__PURE__ */ new Set();
	get size() {
		return this.#disposables.size;
	}
	add(...disposables) {
		for (const disposable of disposables) this.#disposables.add(disposable);
	}
	dispose() {
		for (const disposable of this.#disposables) disposable.dispose();
		this.#disposables.clear();
	}
};
//#endregion
export { CompositeDisposable, isDisposable };

//# sourceMappingURL=index.mjs.map